module.exports = __webpack_public_path__ + "static/Martin-9966044e2321d4c7a4bb05443ee18943.png";